"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBannerConfig = exports.bannerConfigSchema = void 0;
var yup = require("yup");
exports.bannerConfigSchema = yup.object().shape({
    interval: yup.number().optional().default(3).min(3),
});
function validateBannerConfig(obj) {
    return exports.bannerConfigSchema.validateSync(obj);
}
exports.validateBannerConfig = validateBannerConfig;
